import { IsIn, IsInt, IsUUID, Min } from 'class-validator';

/**
 * LabelConfirmationParticipantType - NOT a Prisma enum.
 * `CounterLabelConfirmation.participants` is stored as JSONB; this union
 * gives the API contract a typed shape instead of free-form JSON, per
 * plan.md "lista dei partecipanti (tipo, id, versione)".
 */
export const LABEL_CONFIRMATION_PARTICIPANT_TYPES = [
  'RECIPE',
  'SUB_RECIPE',
  'INGREDIENT',
  'ALLERGEN_SUBSTANCE',
] as const;
export type LabelConfirmationParticipantType =
  (typeof LABEL_CONFIRMATION_PARTICIPANT_TYPES)[number];

/**
 * One entry of the confirmation's participant list: everything whose version
 * bump would otherwise invalidate this confirmation. `version` is the
 * participant's own `labelDataVersion` (or equivalent) at confirmation time.
 */
export class LabelConfirmationParticipantDto {
  @IsIn(LABEL_CONFIRMATION_PARTICIPANT_TYPES)
  type!: LabelConfirmationParticipantType;

  @IsUUID()
  id!: string;

  @IsInt()
  @Min(1)
  version!: number;
}
